import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  HostListener,
} from '@angular/core';
import { ModalService } from '@shared/errors/modal/modal.service';
import { ErrorRendered } from '@core/types/error.type';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import moment from 'moment';
import { BackendTimeEndpoint } from '@core/endpoints/backend-time.endpoint';
import { Router } from '@angular/router';
import { BackendTimeInterface } from '@core/interfaces/backend-time.interface';
import {
  FooterType,
  HOME_SPLASH,
  LOAN_SPLASH,
  OutOffice,
  ACCOUNT_SPLASH,
  ENROLLMENT_SPLASH,
  TITLE_PAGE,
  urlHome,
  ftdUrl,
  AccUrl,
  currentProduct,
  FTD_SPLASH,
  urlPublicWeb,
  ListEnvironments,
  CurrentProductType,
  urlDPFPublicWeb,
  utmAccountWeb,
  utmDpfWeb,
} from './default.config';
import { DomSanitizer } from '@angular/platform-browser';
import { AfterViewChecked } from '@angular/core';
import { FacetecVideoModalComponent } from '@shared/information/modal/facetec-video-modal/facetec-video-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { NuDataService } from '@core/services/nudata/nudata.service';
import { environment } from '@env/environment';

@Component({
  selector: 'shell-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
})
export class DefaultComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked {
  readonly closeError: ErrorRendered = '';
  public error: ErrorRendered = '';
  private destroy$ = new Subject<void>();
  routerOutlet = true;
  hiddenRouterOutLet = true;
  gtmPath: any;
  setTimeOut: any;
  setInterval: any;
  showLoanOptions = false;
  outOfficeData: BackendTimeInterface = {
    isAvailable: false,
    allowedSchedule: false,
    message: '',
  };

  timeStart = '';
  timeEnd = '';
  footerType: FooterType = FooterType.DEFAULT;
  footerDefault = FooterType.DEFAULT;
  footerHome = FooterType.HOME;
  footerLoan = FooterType.LOAN;
  footerFtd = FooterType.FTD;
  footerFtdConfig = FooterType.FTD_CONFIG;
  showCurrentProduct: boolean = false;
  showMoreInformationProduct: boolean = false;
  currentProduct: CurrentProductType;
  currentProductTitle = currentProduct.PREFERRED_ACCOUNT;

  initHome = '';
  constructor(
    public modalService: ModalService,
    public messageBusService: MessageBusService,
    public microFrontendRouter: MicroFrontendRouter,
    private backendTimeEndpoint: BackendTimeEndpoint,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private nuDataService: NuDataService,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.messageBusService
      .on$('shell', 'footer.type')
      .pipe(tap((footerType: FooterType) => (this.footerType = footerType)))
      .subscribe();

    this.messageBusService
      .on$('shell', 'showLoanOptions')
      .pipe(tap((show: boolean) => (this.showLoanOptions = show)))
      .subscribe();

    this.messageBusService
      .on$('shell', 'openVideoFacetec')
      .pipe(tap(() => this.openVideoFacetec()))
      .subscribe();
    
    this.messageBusService
      .on$('shell', 'showCurrentProduct')
      .pipe(tap((data: any) => {
        this.showCurrentProduct = data.show;
        this.showMoreInformationProduct = data.show;
        this.currentProduct = data.currentProduct;
      } 
        

      ))
      .subscribe();

    this.messageBusService
      .on$('shell', 'enrollmentGotoForm')
      .pipe(
        tap((origin: string) => {
          this.messageBusService.emit('shell', 'enrollmentContinue', origin);
        }),
      )
      .subscribe();

    //Controlador de biometria en microfront
    this.messageBusService
      .on$('shell', 'biometricsGotoForm')
      .pipe(
        tap((origin: string) => {
          this.messageBusService.emit('shell', 'biometricContinue', origin);
        }),
      )
      .subscribe();

    //Controlador de validacion de documentos en microfront
    this.messageBusService
      .on$('shell', 'documentGotoForm')
      .pipe(
        tap((origin: string) => {
          this.messageBusService.emit('shell', 'documentContinue', origin);
        }),
      )
      .subscribe();

    this.messageBusService
      .on$('shell', 'professionGotoForm')
      .pipe(
        tap((origin: string) => {
          this.messageBusService.emit('shell', 'professionContinue', origin);
        }),
      )
      .subscribe();

    this.messageBusService
      .on$('shell', 'occupationGotoForm')
      .pipe(
        tap((origin: string) => {
          this.messageBusService.emit('shell', 'occupationContinue', origin);
        }),
      )
      .subscribe();

    // Seteo de NUDATA
    this.messageBusService
      .on$('shell', 'nudata.set-parameters')
      .pipe(
        tap((valueSet: any) => {
          this.nuDataService.SetInitialData(
            valueSet.sessionId,
            valueSet.placement,
            valueSet.placementPage,
          );
        }),
      )
      .subscribe();

    this.messageBusService
      .on$('shell', 'nudata.get-value')
      .pipe(tap(() => this.nuDataService.obtainWidgetData()))
      .subscribe();

    this.getBackendTime();
  }

  openVideoFacetec() {
    this.dialog.open(FacetecVideoModalComponent).afterClosed().subscribe();
  }

  ngAfterViewChecked(): void {
    this.cd.detectChanges();
  }

  getBackendTime() {
    clearInterval(this.setInterval);
    this.backendTimeEndpoint
      .getBackendTime()
      .pipe(
        takeUntil(this.destroy$),
        catchError(() => {
          // When return error, the backend status is out office
          this.outOfficeData.isAvailable = false;
          this.routerOutlet = false;
          // this.handleNotOutOfTime();

          return of();
        }),
        tap((data: BackendTimeInterface) => {
          this.outOfficeData = data;
        }),
        tap(({ isAvailable, allowedSchedule }) => {
          if (isAvailable && allowedSchedule) {
            this.handleNotOutOfTime();
          } else {
            this.handleRouterOutLet();
          }
        }),
      )
      .subscribe();
  }

  // tag event when active outOffice
  emitGTMOutOffice() {
    const gtmPath = this.getGTMPath();
    this.messageBusService.emit('shell', 'google-tag-manager.event', {
      event: 'button-event',
      eventCategory: 'Complementos',
      eventAction: 'Fuera de horario',
      eventLabel: `Popup - ${gtmPath?.pageTitle}`,
    });
  }

  handleNotOutOfTime() {
    clearTimeout(this.setTimeOut); //In order not have delay in render
    this.routerOutlet = true;
    this.hiddenRouterOutLet = false;
  }

  handleRouterOutLet() {
    this.hiddenRouterOutLet = true;
    this.setTimeOut = setTimeout(() => {
      this.emitGTMOutOffice();
      this.routerOutlet = false;
    }, 3000);
  }

  ngAfterViewInit(): void {
    this.onErrors();
  }

  onErrors(): void {
    this.messageBusService
      .on$<any>('shell', 'modal.error')
      .pipe(
        takeUntil(this.destroy$),
        tap((error) => error.error?.code && this.onGTMError(error)),
        tap(({ component }) => (this.error = component)),
        tap(() => this.cd.detectChanges()),
      )
      .subscribe();
  }

  onGTMError(error: any) {
    // Obtener la ruta actualizada mediante el bus
    this.gtmPath = this.getGTMPath();
    if (!this.gtmPath) {
      setTimeout(() => {
        this.setTimeOutTag(error);
      }, 3000);
    } else {
      this.emitErrorTag(this.gtmPath, error);
    }
  }

  getGTMPath(): any {
    return this.messageBusService.getValue('shell', 'google-tag-manager.path');
  }

  setTimeOutTag(error: any) {
    this.gtmPath = this.getGTMPath();
    if (!this.gtmPath?.pageTitle) {
      this.gtmPath.pageTitle = 'TimeOut';
    }
    this.emitErrorTag(this.gtmPath, error);
  }

  emitErrorTag(gtmPath: any, error: any) {
    this.messageBusService.emit('shell', 'google-tag-manager.event', {
      event: 'error-event',
      eventCategory: `Error - ${gtmPath?.pageTitle}`,
      eventAction: `${error?.error?.code} - ${error?.error?.description}`,
      eventLabel: `${error?.error?.errorType}`,
    });
  }

  clickedLogo() {
    const logoPath = this.messageBusService.getValue('shell', 'gtm-logo.path');
    if (!logoPath) return;
    this.modalService.close();
    this.messageBusService.emit('shell', 'google-tag-manager.event', logoPath);
    this.showLoanOptions = false;
    const currentRoute = this.router.url.split('/');
    //Validate if it is Home (PLD or Onboarging) should send to Splash but if split> 2 (other routes) send to Home (PLD or Onboarging)
    if (this.router.url.indexOf(LOAN_SPLASH) >= 0) {
      this.initHome = HOME_SPLASH;
    } else if (this.router.url.indexOf(FTD_SPLASH) >= 0) {
      this.initHome = FTD_SPLASH;
    } else if (this.router.url.indexOf(ACCOUNT_SPLASH) >= 0) {
      this.initHome = ACCOUNT_SPLASH;
    } else if (this.router.url.indexOf(ENROLLMENT_SPLASH) >= 0) {
      this.initHome = HOME_SPLASH;
    } else {
      currentRoute.length <= 2 ? (this.initHome = HOME_SPLASH) : (this.initHome = currentRoute[1]);
    }
    document.title = TITLE_PAGE;
    this.validateRouter(this.initHome);
  }

  validateRouter(productRoute: string): void {
    const urlString = window.location.hash.split('?')[0]; 
    if (productRoute == FTD_SPLASH) {
       if (ftdUrl.firstPage.indexOf(urlString)>=0) {
        this.gotoPublicWebDPF('_self', true);
        return;
      } else { 
        window.location.href = window.location.origin + ftdUrl.firstPage;
      }
    } else if (productRoute === ACCOUNT_SPLASH) {
      
      if (AccUrl.preferentialPen.indexOf(urlString)>=0 || AccUrl.preferentialUsd.indexOf(urlString)>=0) {
        this.gotoPublicWeb('_self', true);
        return;
      } else {
         window.location.href = window.location.origin + AccUrl.preferentialUsd;
      }
    } else {
      window.location.href = window.location.origin + AccUrl.preferentialUsd;
    }
    window.location.reload();
  }

  simulateLoan() {
    this.messageBusService.emit('shell', 'showSimulation', true);
  }

  gotoPublicWeb(windowName: string = '_blank', isLogoBtn: boolean) {
    const utm = isLogoBtn? utmAccountWeb.LOGO: utmAccountWeb.BENEFIT_BTN;
    if (environment.production) {
          window.open(urlPublicWeb.PROD+utm, windowName);
    } else {
      const currentLocation = window.location.origin;
      if (currentLocation.indexOf(ListEnvironments.LOCAL) >= 0 || 
         currentLocation.indexOf(ListEnvironments.DEV) >= 0) {
        window.open(urlPublicWeb.DEV+utm, windowName);
      } else if (
        currentLocation.indexOf(ListEnvironments.CAL) >= 0
      ) {
        window.open(urlPublicWeb.CAL+utm, windowName);
      }
    }
  }

  gotoPublicWebDPF(windowName: string = '_blank', isLogoBtn: boolean) {
    const utm = isLogoBtn? utmDpfWeb.LOGO: utmDpfWeb.BENEFIT_BTN;
    if (environment.production) {
       window.open(urlDPFPublicWeb.PROD+utm, windowName);
    } else {
      const currentLocation = window.location.origin;
      if (currentLocation.indexOf(ListEnvironments.LOCAL) >= 0 || 
         currentLocation.indexOf(ListEnvironments.DEV) >= 0) {
        window.open(urlDPFPublicWeb.DEV+utm, windowName);
      } else if (
        currentLocation.indexOf(ListEnvironments.CAL) >= 0
      ) {
        window.open(urlDPFPublicWeb.CAL+utm, windowName);
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    if (window.location.hash == urlHome) {
      window.location.href = window.location.origin;
      return;
    }

    //dpf
    if (window.location.hash == ftdUrl.redirection) {
      window.location.href = window.location.origin + ftdUrl.firstPage;
      return;
    }

    if (
      window.location.hash.indexOf(AccUrl.redirection) >= 0 &&
      window.location.hash.indexOf(AccUrl.firstPage) >= 0
    ) {
      window.location.href = window.location.origin;
      return;
    }
  }
}
